module.exports = __webpack_public_path__ + "static/media/mauritius-oil-spill-t-shirt.1780cafa.png";